export default __webpack_public_path__ + "static/media/filter_icon_toilet.057e3051.svg";